import { StyledButtons } from './StyledButtons';
import { StyledInverseButton } from './StyledInverseButton';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { useCallback } from 'react';
import { XMarkIcon } from '../../Icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SnackbarButtons = _ref => {
  let {
    action,
    id,
    onClose,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const handleOnAction = useCallback(e => {
    if (action?.onClick) {
      action.onClick(e);
    }
    onClose(e);
  }, [action, onClose]);
  return /*#__PURE__*/_jsxs(StyledButtons, {
    theme: theme,
    className: 'ids-snackbar-buttons',
    children: [action && /*#__PURE__*/_jsx(StyledInverseButton, {
      actionType: 'action',
      className: 'ids-snackbar-action-button',
      onClick: handleOnAction,
      id: id ? `snackbar-action-button-${id}` : 'snackbar-action-button-id',
      "data-testid": rest['data-testid'] ? `snackbar-action-button-${rest['data-testid']}` : 'snackbar-action-button-data-testid',
      children: action?.label
    }), /*#__PURE__*/_jsx(StyledInverseButton, {
      actionType: 'close',
      className: 'ids-snackbar-close-button',
      onClick: onClose,
      id: id ? `snackbar-close-button-${id}` : 'snackbar-close-button-id',
      "data-testid": rest['data-testid'] ? `snackbar-close-button-${rest['data-testid']}` : 'snackbar-action-button-data-testid',
      children: /*#__PURE__*/_jsx(XMarkIcon, {
        fontSize: '14px',
        color: theme.tokens.ComponentSnackbarColorButton
      })
    })]
  });
};